import React from "react";

const IconViewAllArrowRight = () => {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path
                d="M17.6569 6.00037L23.3137 11.6572L17.6569 17.3141"
                stroke="currentColor"
                strokeLinecap="round"
            />
            <path d="M23 11.6572L4 11.6572" stroke="currentColor" strokeLinecap="round" />
        </svg>
    );
};

export default IconViewAllArrowRight;
